import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-luma-color-large.tsx
/**
* icon.24.logo.luma.color.large
*
* ![](data:image/svg+xml;base64,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)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11841
*/
const Icon24LogoLumaColorLarge = memo(function Icon24LogoLumaColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	const idc = `${id}2`;
	const idd = `${id}3`;
	const ide = `${id}4`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#000",
				d: "M4.208 7.498 12 3v17.996l-7.792-4.499z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "m12 20.998-7.792-4.499L12 12l7.793 4.499z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "m12 20.998-7.792-4.499L12 12l7.793 4.499z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idc})`,
				d: "M4.208 7.498 12 3v17.996l-7.792-4.499z",
				style: { mixBlendMode: "screen" }
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idd})`,
				d: "m12 20.998-7.792-4.499L12 12l7.793 4.499z",
				style: { mixBlendMode: "overlay" }
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ide})`,
				d: "M4.208 7.498 12 3v17.996l-7.792-4.499z",
				style: { mixBlendMode: "overlay" }
			}),
			/* @__PURE__ */ jsxs("defs", { children: [
				/* @__PURE__ */ jsxs("linearGradient", {
					id: ida,
					x1: "4.208",
					x2: "19.793",
					y1: "16.499",
					y2: "16.499",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#00A" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#A78DFF"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idb,
					x1: "4.208",
					x2: "19.793",
					y1: "16.499",
					y2: "16.499",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#00A" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#A78DFF"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idc,
					x1: "13.017",
					x2: "6.211",
					y1: "19.978",
					y2: "5.808",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#004EFF" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#0FF"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idd,
					x1: "4.208",
					x2: "19.793",
					y1: "16.499",
					y2: "16.499",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#00A" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#A78DFF"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: ide,
					x1: "13.017",
					x2: "6.211",
					y1: "19.978",
					y2: "5.808",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#004EFF" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#0FF"
					})]
				})
			] })
		]
	});
});
//#endregion
export { Icon24LogoLumaColorLarge };

//# sourceMappingURL=icon-24-logo-luma-color-large.js.map